import React from 'react';

export default function IconGlossary() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.02 3C3.01 3.06 3 3.13 3 3.2V3H3.02Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 5.4002V13.0002C13 13.5502 12.55 14.0002 12 14.0002H4.5C3.67 14.0002 3 13.3302 3 12.5002V3.2002C3 3.8602 3.54 4.4002 4.2 4.4002H12C12.55 4.4002 13 4.8502 13 5.4002Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.2 2H11V4.4H4.2C3.54 4.4 3 3.86 3 3.2C3 2.54 3.54 2 4.2 2Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 7.2002L6 11.2002"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 7.2002L10 11.2002"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.5 10.2002H9.5"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
